export default __webpack_public_path__ + "static/media/9.55df244a.webp";